import axios from "axios";

/*Api para exportação em produção*/

export const api = axios.create({
  baseURL: "https://www.colegiopelicano.com.br/helpdesk/api/",
});


